import styled from 'styled-components';
import {
  Button, Card, Col, Row,
} from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';

export const CenteredRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ _justify }) => _justify || 'space-between'};
`;

export const HStretched = styled(CenteredRow)`
  width: 100%;
  ${({ _position }) => _position && `position: ${_position};`}
  align-items: ${({ _align }) => _align || 'center'};
`;

export const FullSpace = styled(HStretched)`
  justify-content: center;
  ${({ fullPage }) => fullPage && 'height: 100vh;'}
  ${({ preferredHeight }) => preferredHeight && `height: ${preferredHeight};`}
`;

export const Centered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HeaderPrompt = styled(Centered)`
  margin-bottom: 40px;
`;

export const CenteredContentCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Options = styled(Centered)`
  max-width: 1200px;
  width: 100%;
  margin-top: 30px;
`;

export const OptionRow = styled(Row)`
  width: '100%';
  justify-content: center;
`;

export const OptionCol = styled(Col)`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  max-width: 300px;
  min-width: 300px;
  width: 300px;
`;

export const Option = styled(Button)`
  border-radius: 10px;
  width: 100%;
  height: 150px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.grey3};
  background-color: ${({ theme }) => theme.color.backgroundLight2};
  font-size: 20px;
  .option-img {
    max-width: 200px;
  }
`;

export const DividerLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.color.grey2}
`;

export const FormCard = styled(Card)`
  max-width: ${(props) => props.cardwidth};
  width: ${(props) => props.cardwidth};
  background-color: ${({ theme }) => theme.color.backgroundLight2};
  filter: ${({ theme }) => theme.shadow.dark1};
  .ant-card-body {
    ${(props) => (props.paddings ? `padding: ${props.paddings[1]} ${props.paddings[0]}` : 'padding: 64px')};
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const ProviderDescription = styled.div`
  font-weight: 100;
  color: ${({ theme }) => theme.color.grey3};
  font-size: 14px;
  text-align: center;
  margin-bottom: 30px;
`;

export const ModalContentInvite = styled.p`
  position: static;
  left: 0%;
  right: 0%;
  top: 20.86%;
  bottom: 0%;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 155%;

  /* or 22px */

  /* Gray 1 */
  color: #333333;


  /* Inside Auto Layout */
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 10px 0px;
`;

export const CustomCheckBox = styled(Checkbox)`
.ant-checkbox .ant-checkbox-inner {
  border-color: ${(props) => (props.color === 'red' ? 'red' : undefined)};
}`;
